import React from 'react';
import styled from 'styled-components';
import * as types from '../../actions/actionTypes';

import Text from '../common/Text';
import Picture from '../image/CloudFrontPicture';
import InternalLink from '../InternalLink';

const CurrentHashtagWinner = () => {
    const StyledCurrentHashtagWinner = styled.div`
        &.schnoffle-hashtag-winner img {
          max-heigth: 60vh;
          max-width: 60vw;
        }

        & .schnoffle-hashtag-winner-text {
          margin-bottom: 2em;
        }
    `;

    return (
        <StyledCurrentHashtagWinner className='schnoffle-hashtag-winner'>
            <Text.Heading
                text='Gewinnerin Juni 2019 &hearts; Carina aka Kleines Farb - Tupferl'
                level={3}
            />
            <p className='schnoffle-hashtag-winner-text'>
                <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                        payload: {
                            sewpatId: 'martha',
                            patternid: 24472,
                        },
                        meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } },
                    }}
                >
                    Dieser Entwurf&nbsp;
                </InternalLink>
                des Designerstückes <InternalLink
                    to={{
                        type: types.NAVIGATED_TO_SEWPAT_VIEW,
                        payload: { sewpatId: 'martha' },
                    }}
                >
                "Martha"&nbsp;
            </InternalLink>
                eingereicht von <a
                href='https://www.facebook.com/FarbTuepfelchen/posts/2410162472546984'
            >Carina aka Kleines Farb - Tupferl</a>,
                gewinnt die Junirunde
                des #schnoffle Hashtag Wettbewerbs #springschnoffle.
            </p>
            <InternalLink
                to={{
                    type: types.NAVIGATED_TO_SINGLE_PATTERN_VIEW,
                    payload: {
                        sewpatId: 'martha',
                        patternid: 24472,
                    },
                    meta: { query: { colors: '000000,ffffff,4c4c4d,5c9dc0,5174ef,5bc5c6' } },
                }}
            >
                <Picture
                    src='schnoffle-gewinner-q2-19.png'
                    webp='sschnoffle-gewinner-q2-19.webp' png schnoffle
                />
            </InternalLink>
            <p>Bitte melde Dich per <a
                href='mailto:wir@schnoffle.de'
            >E-Mail</a> bei uns, damit wir uns
                bzgl. des gewonnenen Nähpaketes austauschen können.</p>
        </StyledCurrentHashtagWinner>
    );
};

export default CurrentHashtagWinner;



// WEBPACK FOOTER //
// ./src/components/hashtag/CurrentHashtagWinner.js